import React, { useEffect } from 'react'
import { useNetworkStatus } from './utils/DeviceDetails'
import { enqueueNotistack } from '@am92/react-design-system'


const NetworkStatusToast = () => {
  const isOnline = useNetworkStatus()
  useEffect(() => {
    if (!isOnline) {
      enqueueNotistack({
        message: 'Check your internet connection',
        autoHideDuration: 3000
      })
    }
  }, [isOnline])

  return <></>
}

export default NetworkStatusToast
